import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Tooltip from '@mui/joy/Tooltip';
import Stack from '@mui/joy/Stack';
function InteractiveLogo({logo_url, height=undefined, width=undefined}: {logo_url: string, height?: number | undefined, width?: number | undefined}) { //
    const navigate = useNavigate();
    const [scrollY, setScrollY] = useState(0);
    const handleScroll = () => {
            setScrollY(document.body.scrollTop);
        };

    useEffect(() => {
        document.body.addEventListener('scroll', handleScroll);
        return () => document.body.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <Tooltip
            title={ scrollY ? "Back to top" : "Home" }
            placement="bottom"
            arrow>
            <Stack alignItems="center">
            <img
                className="fh-logo"
                onClick={() => {
                    // if we're scrolled down, scroll to top
                    // othwerwise, redirect to '/'
                    if (scrollY > 0) {
                        document.body.scrollTo({top: 0, left: 0, behavior: 'smooth'});
                    } else {
                        navigate('/');
                    }
                }
                }
                style={{ cursor: "pointer" }}
                height={height}
                width={width}
                src={logo_url}
                alt="Fancy Hands Logo" />
            </Stack>
    </Tooltip>
    );
}

export default function FancyHandsLogo() {
    const logo_url =  import.meta.env.PROD ? "/fh-standard-2040x440.png" : "/fh-standard-2040x440.DEV.png";
    return <InteractiveLogo width={175} logo_url={logo_url} />;
}


export function FLogo() {
    const logo_url =  import.meta.env.PROD ? "/f-icon-512x512.png" : "/f-logo-grad.DEV.svg";
    return <InteractiveLogo height={42} logo_url={logo_url} />;
}
